import { Tooltip } from "antd";
import React from "react";
import { CalculateType, formatVal, formatter } from "../../../utils/utils";
import Fuse from "fuse.js";

export const renderToolTip = (
  {
    DealerName,
    LowRange,
    HighRange,
    FactorDetails,
    DealerAvgMultiple,
    Performance,
    DealerBrandBreakout,
    GroupName,
    "12 Month New Car Sales Growth (%)": salesGrowth,
    "12 Month Revenue Growth (%)": revGrowth,
    "3 Year New Car Sale Growth (%)": carSale,
    "3 Year Revenue Growth (%)": yearGrowth,
    "12 Month New Sales Growth (BEV)": newSalesGrowth,
    "12 Month New Sales Growth (Hybrid)": hybridSalesGrowth,
    "12 Month Used Sales Growth": usedSalesGrowth,
    "12 Month Revenue Growth (BEV)": revGrowthBEV,
    "12 Month Revenue Growth (Hybrid)": revGrowthHybrid,
    City,
    StateCode,
    ["Suggested Radius"]: suggestedRadius
  },
  factorMapping,
  alias
) => {
  const renderFactorDetailsSection = (
    aliasList,
    factorMapping,
    FactorDetails
  ) => {
    return (
      <div style={{ fontSize: "12px", color: "black" }}>
        <div>
          <b>{DealerName}</b>
        </div>
        <b style={{ fontSize: "10px" }}>{GroupName}</b>
        <hr />
        {/* Render the new growth metrics */}
        {alias === "Performance" && (
          <div style={{ marginBottom: "3px" }}>
            {/* <div>
              <b>12 Month New Sales Growth(%):</b> {salesGrowth ?? "-"}
            </div>
            <div>
              <b>12 Month Revenue Growth(%):</b> {revGrowth ?? "-"}
            </div> */}
            <div>
              <b>3 Year New Sale Growth(%):</b> {carSale ?? "-"}
            </div>
            <div>
              <b>3 Year Revenue Growth(%):</b> {yearGrowth ?? "-"}
            </div>
            {/* <div>
              <b>12 Month New Sales Growth(%)(BEV):</b> {newSalesGrowth ?? "-"}
            </div>
            <div>
              <b>12 Month New Sales Growth(%)(Hybrid):</b>{" "}
              {hybridSalesGrowth ?? "-"}
            </div>
            <div>
              <b>12 Month Used Sales Growth(%):</b> {usedSalesGrowth ?? "-"}
            </div>
            <div>
              <b>12 Month Revenue Growth(%)(BEV):</b> {revGrowthBEV ?? "-"}
            </div>
            <div>
              <b>12 Month Revenue Growth(%)(Hybrid):</b>{" "}
              {revGrowthHybrid ?? "-"}
            </div> */}
          </div>
        )}
        <div>
          {FactorDetails && (
            <div
              style={{
                display: "flex",
                flexWrap: "wrap",
                gap: "4px",
                lineHeight: "14px",
              }}
            >
              {factorMapping
                .filter((factor) => aliasList.includes(factor.Alias))
                .map((factor) => {
                  const { ID, Alias, FactType } = factor;
                  return (
                    <span key={ID}>
                      <b>{Alias}</b>: {formatVal(FactType, FactorDetails?.[ID])}
                    </span>
                  );
                })}
            </div>
          )}
        </div>
      </div>
    );
  };

  // Usage
  if (alias === "Performance") {
    return renderFactorDetailsSection(
      [
        "PVR New",
        "F&I New",
        "Days to Turn",
        "Google Bus Rating",
        "New Vehicle Sales Price",
        "New/Used Ratio",
        "Content Upgrades",
      ],
      factorMapping,
      FactorDetails
    );
  }

  if (alias === "Environment") {
    return renderFactorDetailsSection(
      [
        "Population growth",
        "Median Household Income",
        "Unemployment Rate",
        "% Owner-Occupied Housing",
        "Dealer Density (per million)",
        "Personal Income (avg) Customer",
      ],
      factorMapping,
      FactorDetails
    );
  }
  const factors = Array.isArray(factorMapping) ? factorMapping : [];
  const fuseOptions = {
    includeScore: true,
    threshold: 0.4, //(0.0 = exact, 1.0 = very fuzzy)
    keys: ["navatar_name"],
  };
  const formatRev = (rev) => {
    if (rev >= 1000000) {
      return `$${(rev / 1000000).toFixed(2)}M`;
    }
    return `$${(rev / 1000).toFixed(0)}K`;
  };
  const orderedAliases = [
    "Performance",
    "Environment",
    "Opportunity",
    "Value",
    "PVR New",
    "F&I New",
    "New Vehicle Sales Price",
    "# Vehicle Sold",
    "New/Used Ratio",
    "Days to Turn",
    "Content Upgrades",
    "Dealer Density (per million)",
    "Unemployment Rate",
    "% Owner-Occupied Housing",
    "Median Household Income",
    "Population growth",
    "Google Bus Rating",
    "Website Traffic",
  ];
  // Sort factorMapping based on orderedAliases
  const sortedFactors = factorMapping
    .filter((factor) => factor.ID !== 120 && (factor.ID < 171 || factor.ID > 175))
    .sort((a, b) => {
      return orderedAliases.indexOf(a.Alias) - orderedAliases.indexOf(b.Alias);
    });
  return (
    <div style={{ fontSize: "12px", color: "black" }}>
      <div>
        <b>{DealerName}</b>
      </div>
      <div>
        <b style={{ fontSize: "10px" }}>{City ? City + "," : ""} {StateCode || ""}</b>
      </div>
      <b style={{ fontSize: "10px" }}>{GroupName}</b>
      {/* {LowRange && ( */}
      <>
        <hr />
        <div>
          <span>
            {" "}
            <div>[Monthly Averages based on prior 3 months]</div>
            <b>Valuation Range :</b> {formatter.format(LowRange)} -{" "}
            {formatter.format(HighRange)}{" "}
          </span>
          <br />
          {/* {factors
            .filter((factor) => factor.ID == 120)
            .map((factor) => {
              const { ID, Alias, FactType } = factor;
              return (
                <div>
                  <span>
                    <b>{Alias} </b>: {formatVal(FactType, FactorDetails[ID])}
                  </span>
                </div>
              );
            })} */}
          <span>
            {" "}
            <b>Dealer Multiple :</b> {formatVal("Decimal", DealerAvgMultiple)}
          </span>
          <br/>
          <span>
            {" "}
            <b>Suggested Radius: </b> {suggestedRadius ? suggestedRadius : ""}
          </span>
          <br />
          {/* <span>
            {" "}
            <b>Performance Score :</b>{" "}
            {Performance !== undefined
              ? formatVal("Decimal", Performance)
              : null}
          </span> */}
        </div>
        {FactorDetails && (
          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              gap: "4px",
              lineHeight: "14px",
            }}
          >
            {sortedFactors.map((factor) => {
              const { ID, Alias, FactType } = factor;
              let value = formatVal(FactType, FactorDetails?.[ID]);

              // Show exact backend value for "# Vehicle Sold" - removed division by 3
              // if (Alias === "# Vehicle Sold" && FactorDetails?.[ID]) {
              //   value = formatVal(FactType, FactorDetails[ID] / 3);
              // }

              return (
                <span key={ID}>
                  <b>{Alias}</b>: {value}
                </span>
              );
            })}
          </div>
        )}
      </>
      {/* )} */}
      <div>
        <hr style={{ border: "1px dashed #777" }} />

        <b>DEALER BRAND BREAKOUT</b>
        {factorMapping
          .filter((factor) => factor.ID == 120)
          .map((factor) => {
            const { ID, Alias, FactType } = factor;
            return (
              <div>
                <span>
                  <b>{Alias} </b>: {formatVal(FactType, FactorDetails?.[ID])}
                </span>
              </div>
            );
          })}
        {DealerBrandBreakout &&
          Object.keys(DealerBrandBreakout).map((dealerId) => {
            const dealer = DealerBrandBreakout[dealerId];
            // Create a new Fuse instance for each dealer
            const fuse = new Fuse(
              [{ navatar_name: dealer.navatar_name }],
              fuseOptions
            );

            // Perform the fuzzy search
            const fuzzyResult = fuse.search(DealerName);

            // Check if the match score is below 0.3, meaning it's a good match (similar enough)
            const isFuzzyMatch =
              fuzzyResult.length > 0 && fuzzyResult[0].score <= 0.4;

            return (
              <div key={dealerId}>
                <div style={{ fontWeight: "bold" }}>
                  {/* Only show navatar_name if it's not a good fuzzy match with DealerName */}
                  {isFuzzyMatch ? "" : dealer.navatar_name}{" "}
                  {dealer.brand_name ? `(${dealer.brand_name})` : ""}
                  {/* {dealer.navatar_name ? dealer.navatar_name : "-"}  */}
                </div>
                <span style={{ paddingLeft: "10px" }}>
                  <b>Rev:</b> {formatRev(dealer.rev)}; <b>New:</b>{" "}
                  {Math.round(dealer.new)}, <b>Used:</b>{" "}
                  {Math.round(dealer.used)}
                </span>
              </div>
            );
          })}
      </div>
      {/* <div>*Monthly Averages based on prior 3 months</div> */}
    </div>
  );
};

const renderFactorDetails = (
  factorMapping,
  FactorDetails,
  id,
  renderAverage
) => {
  const factor = factorMapping.find((obj) => obj.ID == id);
  return (
    FactorDetails[id] &&
    formatVal(
      factor.FactType,
      FactorDetails[id].Total !== undefined
        ? renderAverage
          ? FactorDetails[id]?.Count !== 0
            ? FactorDetails[id]?.Total / FactorDetails[id]?.Count
            : 0
          : FactorDetails[id]?.Total
        : FactorDetails[id]
    )
  );
};

export const getColumns = (factorMapping, handleDealerNameClick) => {
  return [
    {
      title: "Name",
      dataIndex: "DealerName",
      sorter: (a, b) => a.DealerName.localeCompare(b.DealerName),
      width: 200,
      fixed: "left",
      render: (value, record) => {
        return (
          <Tooltip color="white" title={renderToolTip(record, factorMapping)}>
            <span onClick={() => handleDealerNameClick(record)}>{value}</span>
          </Tooltip>
        );
      },
    },
    {
      title: " Primary Brand",
      dataIndex: "Brand",
      className: "Brand",
      fixed: "left",
      sorter: (a, b) => a.Brand.localeCompare(b.Brand),
      width: 100,
    },
    {
      title: "Group",
      dataIndex: "GroupName",
      sorter: (a, b) => a.GroupName?.localeCompare(b.GroupName),
      width: 140,
    },
    {
      title: "City",
      dataIndex: "City",
      sorter: (a, b) => a.City.localeCompare(b.City),
      width: 90,
    },
    {
      title: "State",
      dataIndex: "StateCode",
      sorter: (a, b) => a.StateCode.localeCompare(b.StateCode),
      width: 90,
    },
    {
      title: "Avg Revenue TTM",
      dataIndex: "FactorDetails",
      sorter: (a, b) => a.FactorDetails["120"] - b.FactorDetails["120"],
      render: (FactorDetails, renderAverage) => {
        // console.log(FactorDetails[120]),
        // formatVal(
        //   FactorDetails["Avg Revenue TTM"].FactType,
        //   FactorDetails["Avg Revenue TTM"].Value
        // ),
        const id = "120";
        return (
          FactorDetails[id] && (
            <span>{`$${CalculateType(
              FactorDetails[id].Total !== undefined
                ? renderAverage
                  ? FactorDetails[id]?.Count !== 0
                    ? FactorDetails[id]?.Total / FactorDetails[id]?.Count
                    : 0
                  : FactorDetails[id]?.Total
                : FactorDetails[id]
            ).join("")}`}</span>
          )
        );
      },
      width: 100,
    },
    {
      title: "ZIP",
      dataIndex: "ZipCode",
      sorter: (a, b) => a.ZipCode.localeCompare(b.ZipCode),
      width: 60,
    },
    {
      title: "Valuation(Low)",
      dataIndex: "LowRange",
      className: "",
      render: (value) => `$${CalculateType(value).join("")}`,
      sorter: (a, b) => a.LowRange - b.LowRange,
      width: 90,
    },
    // {
    //   title: "Val $",
    //   dataIndex: "Valuation",
    //   className: "bold",
    //   render: (value) => `$${CalculateType(value).join("")}`,
    //   sorter: (a, b) => a.Valuation - b.Valuation,
    //   width: 70,
    // },
    {
      title: "Valuation(High)",
      dataIndex: "HighRange",
      className: "",
      render: (value) => `$${CalculateType(value).join("")}`,
      sorter: (a, b) => a.HighRange - b.HighRange,
      width: 90,
    },
    {
      title: "Dealer Multiple",
      dataIndex: "DealerAvgMultiple",
      className: "",
      sorter: (a, b) => a.DealerAvgMultiple - b.DealerAvgMultiple,
      render: (value) => formatVal("Decimal", value),
      width: 90,
    },
    {
      title: "State Brand Multiple",
      dataIndex: "SBMultiple",
      sorter: (a, b) => a.SBMultiple - b.SBMultiple,
      render: (value) => formatVal("Decimal", value),
      width: 110,
    },
    {
      title: "Performance",
      dataIndex: "Performance",
      sorter: (a, b) => a.Performance - b.Performance,
      render: (value) => formatVal("Decimal", value),
      width: 80,
    },
    {
      title: "PVR",
      dataIndex: "FactorDetails",
      key: "PVR",
      sorter: (a, b) => a.FactorDetails["7"] - b.FactorDetails["7"],
      render: (FactorDetails, renderAverage = false) =>
        renderFactorDetails(factorMapping, FactorDetails, "7", renderAverage),
      width: 60,
    },
    {
      title: "F&I",
      key: "F&I",
      dataIndex: "FactorDetails",
      sorter: (a, b) => a.FactorDetails["2"] - b.FactorDetails["2"],
      render: (FactorDetails, renderAverage = false) =>
        renderFactorDetails(factorMapping, FactorDetails, "2", renderAverage),
      width: 60,
    },
    {
      title: "New / Used",
      key: "New / Used",
      dataIndex: "FactorDetails",
      sorter: (a, b) => a.FactorDetails["90"] - b.FactorDetails["90"],
      render: (FactorDetails, renderAverage = false) =>
        renderFactorDetails(factorMapping, FactorDetails, "90", renderAverage),
      width: 80,
    },
  ];
};
